
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import Accordion from '../../../../components/accordion/Accordion'
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown';
import commonStyles from "../ManageForms.styles"
import Label from '../../../../components/label/Label';
import { LABEL_WEIGHT } from '../../../../components/label/constants';
import { ROW_SELECTION_OPTIONS } from '../../../../components/richgrid/constants';
import RichGrid from '../../../../components/richgrid/RichGrid';
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks';
import useTxSearchParams from '../../../../../libs/txsearchparams/TxSearchParamsHook';
import { QUERY_PARAMS } from '../../constants';
import { componentKey, setSelectedStateName, setSelectedFormName, setFormNameList, setSelectedTaxYear, setPayerList, setSelectedPayer, setPaginationState, setManageFormsStatePayrollGridData, setUrlFormIdParam, setUrlPayerIdParam } from './ManageStatePayrollFormsSlice';
import { getManageStatePayrollStateNamesList, getManageStatePayrollFormsList, getManageStatePayrollTaxYearsList, getManageStatePayrollPayersList, getManageFormsStatePayrollGridData, viewManageStatePayrollPDF } from './ManageStatePayrollFormsSaga';
import { MANAGE_FORMS_LOADING_STATES, MANAGE_FORMS_MESSAGE_MAP } from '../constants';
import Loadable from '../../../../components/loadable/Loadable';
import Button from '../../../../components/button/Button';
import Icons from '../../../../components/icons/Icons';
import { VEC_ICON_NAME } from '../../../../components/icons/constants';

const ManageStatePayrollForms = () => {

    useGarbageCollector(componentKey);

    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();

    const { loadingState, stateNameList, selectedStateName, formNameList, selectedFormName, taxYearList, selectedTaxYear, payerList, selectedPayer, paginationState, manageFormsStatePayrollGridData, urlFormIdParam, urlPayerIdParam } = useSelector(state => state[componentKey]);

    useEffect(() => {
        const stateParamFromUrl = queryParams.get(QUERY_PARAMS.STATE_ID)
        const formIdParamFromUrl = queryParams.get(QUERY_PARAMS.FORM_ID)
        const taxYearParamFromUrl = queryParams.get(QUERY_PARAMS.TAX_YEAR)
        const payerIdParamFromUrl = queryParams.get(QUERY_PARAMS.PAYER_ID)

        dispatch(setUrlFormIdParam(formIdParamFromUrl))
        dispatch(setUrlPayerIdParam(payerIdParamFromUrl))

        dispatch(getManageStatePayrollStateNamesList({ urlStateParam: stateParamFromUrl }));
        dispatch(getManageStatePayrollTaxYearsList({ urlTaxYearParam: taxYearParamFromUrl }));

    }, []);

    useEffect(() => {
        if (selectedStateName?.value) {
            dispatch(getManageStatePayrollFormsList({ formNames: selectedStateName?.value, urlFormIdParam: urlFormIdParam }));
        }
        dispatch(setFormNameList([]));
        dispatch(setSelectedFormName({ label: "", value: "" }))

    }, [selectedStateName]);

    useEffect(() => {
        if (selectedFormName?.value) {
            dispatch(getManageStatePayrollPayersList({ FormId: selectedFormName?.value, urlPayerIdParam: urlPayerIdParam }));

        }
        dispatch(setPayerList([]));
        dispatch(setManageFormsStatePayrollGridData([]))
        dispatch(setSelectedPayer({ label: "", value: "" }))
    }, [selectedFormName]);

    useEffect(() => {
        if (selectedFormName?.value && selectedPayer?.value && selectedTaxYear?.value) {
            dispatch(getManageFormsStatePayrollGridData({ payer: selectedPayer?.value, taxYear: selectedTaxYear?.value, formId: selectedFormName?.value }))
        }
    }, [selectedFormName, selectedPayer, selectedTaxYear]);

    const MANAGE_STATE_PAYROLL_FORMS_COLUMN = [
        {
            field: "ReferenceNo",
            header: <Label weight={LABEL_WEIGHT[700]}>Reference Number</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.StatePayrollReferenceNumber || "-"}</span>
        },
        {
            field: "FormName",
            header: <Label weight={LABEL_WEIGHT[700]}>Form Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.FormName || "-"}</span>
        },
        {
            field: "TIN",
            header: <Label weight={LABEL_WEIGHT[700]}>Payer TIN</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.PayerIdNumber || "-"}</span>
        },
        {
            field: "Action",
            header: <Label Label weight={LABEL_WEIGHT[700]} >Action</Label >,
            renderLogic: (row, idx) => (
                <Loadable
                    currentState={loadingState.state}
                    loadingStates={[`${MANAGE_FORMS_LOADING_STATES.FETCHING_VIEW_PDF_LOADING}-${row?.FormId}`]}
                    messageMap={MANAGE_FORMS_MESSAGE_MAP}
                    isNewLoadable={true}
                    isFullWidth={false}
                >
                    <Button title={'View PDF'} style={commonStyles.buttonBackgroundWIcon} onClickCb={() => dispatch(viewManageStatePayrollPDF({
                        formId: row?.FormId,
                        payerId: selectedPayer?.PayerDetailId,
                        formTypeId: selectedFormName?.value,
                        payerName: selectedPayer?.LastName,
                    }))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.VIEW_ICON} /></Button>

                </Loadable>
            ),
        },
    ];

    const Body = (

        <div>
            <div style={commonStyles.dropdownContainer}>
                <div style={commonStyles.selectDropdown}>
                    <div>
                        <Loadable
                            currentState={loadingState.state}
                            loadingStates={[MANAGE_FORMS_LOADING_STATES.FETCHING_STATES_LIST_LOADING]}
                            messageMap={MANAGE_FORMS_MESSAGE_MAP}
                            isNewLoadable={true}
                            isFullWidth={false}
                        >
                            <SelectDropdown
                                name="selectedStateName"
                                label="State Name *"
                                placeHolder="Select State Name"
                                options={stateNameList}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedStateName(selectedOption));
                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.STATE_ID, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.STATE_ID)
                                    }
                                    setQueryParams(queryParams);
                                    dispatch(setPaginationState({ PageNumber: 1, Skip: 0 }));
                                }}
                                value={selectedStateName}

                            />
                        </Loadable>
                    </div>
                    <div>
                        <Loadable
                            currentState={loadingState.state}
                            loadingStates={[MANAGE_FORMS_LOADING_STATES.FETCHING_FORMS_LIST_LOADING]}
                            messageMap={MANAGE_FORMS_MESSAGE_MAP}
                            isNewLoadable={true}
                            isFullWidth={false}
                        >
                            <SelectDropdown
                                name="selectedFormName"
                                label="Form Name *"
                                placeHolder="Select Form"
                                options={formNameList}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedFormName(selectedOption));
                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.FORM_ID, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.FORM_ID)
                                    }
                                    setQueryParams(queryParams);
                                    dispatch(setPaginationState({ PageNumber: 1, Skip: 0 }));
                                }}
                                value={selectedFormName}

                            />
                        </Loadable>
                    </div>
                    <div>
                        <SelectDropdown
                            name="selectedTaxYear"
                            label="Tax Year *"
                            placeHolder="Select Tax Year"
                            options={taxYearList}
                            onSelectCb={(name, selectedOption) => {
                                dispatch(setSelectedTaxYear(selectedOption));
                                if (selectedOption?.value) {
                                    queryParams.set(QUERY_PARAMS.TAX_YEAR, selectedOption?.value)
                                } else {
                                    queryParams.delete(QUERY_PARAMS.TAX_YEAR)
                                }
                                setQueryParams(queryParams);
                                dispatch(setPaginationState({ PageNumber: 1, Skip: 0 }));
                            }}
                            value={selectedTaxYear}
                        />
                    </div>
                    <div>
                        <Loadable
                            currentState={loadingState.state}
                            loadingStates={[MANAGE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]}
                            messageMap={MANAGE_FORMS_MESSAGE_MAP}
                            isNewLoadable={true}
                            isFullWidth={false}
                        >

                            <SelectDropdown
                                name="selectedPayer"
                                label="Payer *"
                                placeHolder="Select Payer"
                                options={payerList}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedPayer(selectedOption));
                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.PAYER_ID)
                                    }
                                    setQueryParams(queryParams);
                                    dispatch(setPaginationState({ PageNumber: 1, Skip: 0 }));
                                }}
                                value={selectedPayer}

                            />
                        </Loadable>
                    </div>
                </div>
            </div>

            <div>
                <Loadable
                    currentState={loadingState.state}
                    loadingStates={[MANAGE_FORMS_LOADING_STATES.FETCHING_GRID_RECORDS_LOADING]}
                    messageMap={MANAGE_FORMS_MESSAGE_MAP}
                    isNewLoadable={true}
                    isFullWidth={false}
                >
                    <RichGrid
                        selectable={false}
                        data={manageFormsStatePayrollGridData}
                        columns={MANAGE_STATE_PAYROLL_FORMS_COLUMN}
                        extractRowKey={(row) => row.ReferenceNumber}
                        selectedRows={manageFormsStatePayrollGridData}
                        paginationProps={{
                            skip: paginationState?.Skip,
                            take: paginationState?.PageSize,
                            takeOptions: ROW_SELECTION_OPTIONS,
                            total: paginationState?.totalRecipients,
                            onChangeTakeCb: (newTake) => {
                                dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                            },
                            onChange: (take, skip) => {
                                dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }))
                            }
                        }}

                    />
                </Loadable>
            </div>
        </div>

    )
    return (
        <div>
            <Accordion header={'State Payroll Forms'} body={Body} active={true} />
        </div>
    )

}

export default ManageStatePayrollForms